import { render, staticRenderFns } from "./PhoneVerification.vue?vue&type=template&id=32bad000&scoped=true"
import script from "./PhoneVerification.vue?vue&type=script&lang=js"
export * from "./PhoneVerification.vue?vue&type=script&lang=js"
import style0 from "./PhoneVerification.vue?vue&type=style&index=0&id=32bad000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bad000",
  null
  
)

export default component.exports